import { useState } from "react";
import { Chat, type ChatMessage } from "@engine/ui";

const seed = (): ChatMessage[] => [
  { id: "s1", author: "system", body: "Welcome — press Enter to chat. I = inventory.", timestamp: Date.now(), channel: "system" },
];

/**
 * Global chat overlay. Always visible regardless of which demo is active.
 * Press Enter to focus the input; Esc blurs. Local-only (no network) for the
 * showcase — wire your `BinaryWsAdapter` send/recv to replace `setMessages`.
 */
export function GlobalChatHud() {
  const [messages, setMessages] = useState<ChatMessage[]>(() => seed());
  const onSend = (text: string): void => {
    setMessages((prev) => [
      ...prev,
      { id: `local-${Date.now()}`, author: "You", body: text, timestamp: Date.now(), channel: "say" },
    ]);
  };
  return <Chat messages={messages} onSend={onSend} />;
}
